export default __webpack_public_path__ + "static/media/backgroundListView.a2dbf04a.png";